import { render, staticRenderFns } from "./TestCountryList.vue?vue&type=template&id=0d1b68b8"
import script from "./TestCountryList.vue?vue&type=script&lang=js"
export * from "./TestCountryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d1b68b8')) {
      api.createRecord('0d1b68b8', component.options)
    } else {
      api.reload('0d1b68b8', component.options)
    }
    module.hot.accept("./TestCountryList.vue?vue&type=template&id=0d1b68b8", function () {
      api.rerender('0d1b68b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/grid/TestCountryList.vue"
export default component.exports